import React, { useContext } from 'react';
import UserContext from '../context/UserContext';
import { FaShoppingBag } from 'react-icons/fa';
import { Redirect } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Items = () => {
	const context = useContext(UserContext);

	const openItem = (item) => {
		context.setProduct(item);
		context.setViewProduct(true);
	};

	const checkProduct = (item) => {
		return context.checkCart(item)
			? context.setCartItem([...context.cartItem, item])
			: toast('Already Added in the cart 🛒🛒!', {
					type: 'warning',
					position: 'top-right',
					autoClose: 2000,
			  });
	};
	if (context.viewProduct) return <Redirect to="/productDetails" />;
	if (context.cart) {
		return <Redirect to="/CartItems" />;
	}
	return (
		<div className="items__container">
			<ToastContainer />
			{context.productItem.map((item) => (
				<div className="individual__item__wrapper" key={item.id}>
					<div className="individual__item__img">
						<img src={item.img} alt={item.category} />
					</div>
					<div className="individual__item__content">
						<h3
							className="individual__item__name"
							// onClick={() => openItem(item)}
						>
							{item.productName}
						</h3>
						<div className="individual__item__price">${item.productPrice}</div>
					</div>
					<div className="item__addtoCart" onClick={() => checkProduct(item)}>
						{context.checkCart(item) ? ' Add to Cart' : 'Added to Cart'}
						<FaShoppingBag />
					</div>
				</div>
			))}
		</div>
	);
};

export default Items;
